import { Col, Container, Row } from "react-bootstrap";
import MusicListDashboard from "../../music_data_components/components/music-list-dashboard";
import NewsListDashboard from "../../news_data_components/components/news-list-dashboard";
import ActivityListDashboard from "../../activity_components/components/activity-list-dashboard";
import { Link } from "react-router-dom";

function DashHome() {
  return <>
    <Container fluid className="p-0 m-0 text_data_admin px-2">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb pb-5 ps-5">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item">
            Dashboard
          </li>
        </ol>
      </nav>
    </Container>
    <Container fluid>
      <Row>
        <Col lg="6" className="py-4">
          <NewsListDashboard />
        </Col>
        <Col lg="6" className="py-4">
          <MusicListDashboard />
        </Col>
      </Row>
      <Row className="mt-5">
        <Col className="py-4 col-12">
          <ActivityListDashboard />
        </Col>
      </Row>
    </Container>
  </>
}
export default DashHome;
